module.exports = __webpack_public_path__ + "static/img/zanwu.e5adf51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zanwu.png
// module id = 8cTi
// module chunks = 26